import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PageLayout from '../../../components/common/PageLayout';
import WarehousesContainer from '../../blocks/WarehousesContainer';
import SupplierAdminHeader from '../../../components/common/SupplierAdminHeader';

function SupplierAdminWarehousesContainer(props) {
  const pageHero = <SupplierAdminHeader supplierId={props.supplierId} title="Warehouses" />;

  return (
    <PageLayout top={pageHero}>
      <WarehousesContainer />
    </PageLayout>
  );
}

const mapStateToProps = (state) => {
  const { supplierId } = state.role;

  return {
    supplierId,
  };
};

export default connect(mapStateToProps, null)(SupplierAdminWarehousesContainer);

SupplierAdminWarehousesContainer.propTypes = {
  supplierId: PropTypes.number.isRequired,
};
